export const flattenChangedItems = (changed = []) =>
  changed.flatMap(({ id, differences }) =>
    differences.map((diff) => ({
      rowKey: `${id}-${diff.field}`,
      category: "changed",
      id,
      ...diff,
    }))
  );

export const flattenOnlyInDev = (onlyInDev = []) =>
  onlyInDev.map(({ id, item }) => ({
    rowKey: `only_in_dev-${id}`,
    category: "only_in_dev",
    id,
    field: "Registro completo",
    item,
  }));

export const flattenOnlyInProd = (onlyInProd = []) =>
  onlyInProd.map(({ id, item }) => ({
    rowKey: `only_in_prod-${id}`,
    category: "only_in_prod",
    id,
    field: "Registro completo",
    item,
  }));

export const buildSyncDataSource = (syncData) => [
  ...flattenChangedItems(syncData?.changed),
  ...flattenOnlyInDev(syncData?.only_in_dev),
  ...flattenOnlyInProd(syncData?.only_in_prod),
];

// Monta o payload do merge a partir da própria resposta do GET,
// mantendo só o que foi marcado (o resto não deve ser mergeado).
export const buildMergePayload = (syncData, selectedRowKeys) => {
  if (!syncData) return null;

  const changed = (syncData.changed || [])
    .map((item) => ({
      ...item,
      differences: item.differences.filter((diff) =>
        selectedRowKeys.includes(`${item.id}-${diff.field}`)
      ),
    }))
    .filter((item) => item.differences.length > 0);

  const onlyInDev = (syncData.only_in_dev || []).filter((entry) =>
    selectedRowKeys.includes(`only_in_dev-${entry.id}`)
  );

  const onlyInProd = (syncData.only_in_prod || []).filter((entry) =>
    selectedRowKeys.includes(`only_in_prod-${entry.id}`)
  );

  return {
    ...syncData,
    changed,
    only_in_dev: onlyInDev,
    only_in_prod: onlyInProd,
  };
};
